import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  ApiService,
  Conference,
  User,
  DateTimeFrame,
  SnackbarService
} from '../../../shared';

@Component({
  selector: 'app-my-schedule-page',
  templateUrl: './my-schedule-page.component.html',
})
export class MySchedulePageComponent implements OnInit {
  title: string = 'schedule';
  subtitle: string = 'thranduil';
  user: User;
  conferences: Conference[];
  dateTimeFrame$: Observable<DateTimeFrame>;

  constructor(
    private apiService: ApiService,
    private snackBarService: SnackbarService
  ) {}

  ngOnInit() {
    this.getMe();
    this.getMyConferences();
    this.dateTimeFrame$ = this.getDateTimeFrame();
  }

  getMe(): void {
    this.apiService.getMe()
      .subscribe(me => {
        this.user = me;
        this.subtitle = `${me.firstName}  ${me.lastName}`;
      });
  }

  getMyConferences(): void {
    this.apiService.getMyConferences()
      .subscribe(conferences => this.conferences = conferences);
  }

  getDateTimeFrame(): Observable<DateTimeFrame> {
    return this.apiService.getDateTimeFrame();
  }

  handleCancelConference(conference: Conference) {
    this.apiService.cancelConference(conference)
      .subscribe(() => {
        this.conferences = this.conferences.filter(c => c.id !== conference.id);
        this.snackBarService.showSuccess('conference in ' + conference.room.name + ' has been canceled');
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule/pages/my-schedule-page/my-schedule-page.component.ts